export default __webpack_public_path__ + "static/media/Club Med - Logo.e9139b94.png";